<template>
    <ul class="map-list">
        <li>
            <a href="http://www.gxzf.gov.cn/zwdt" target="_blank" rel="noopener noreferrer">
                <img src="../../../assets/icon/Map.png">
                <span>自治区的政务地图</span>
            </a>
        </li>

        <li>
            <a href="https://bdc.nngeo.com" target="_blank" rel="noopener noreferrer">
                <img src="../../../assets/icon/Platform.png">
                <span>不动产登记综合服务平台</span>
            </a>
        </li>

        <li>
            <a href="https://dz.nnrig.com/gateway/dpzs/" target="_blank" rel="noopener noreferrer">
                <img src="../../../assets/icon/Monitor.png">
                <span>南宁市地质灾害监测综合管理平台</span>
            </a>
        </li>

    </ul>
</template>
  
<script>
    export default {
        name: 'drawer_icon_list',

        props: {

        },
        
        data () {
            return {
            
            }
        },

        methods: {

        },
    }
</script>
  

<style scoped>

/* 左侧地图列表 */
.map-list{
  box-sizing: border-box;
  list-style-type: none;
  margin: 1rem;
  padding: 0;
  line-height: 0px;
  text-align: left;
}

.map-list li{
  position: relative;
  text-align: center;
  display: inline-block;
  vertical-align: middle;
  width: 4rem;
  height: 4.5rem;
  margin-bottom: 0.7rem;
  margin-left: 0.5rem;
  cursor: pointer;
}

.map-list a{
  position: absolute;
  line-height: 1rem;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font-size: 0.1rem;
  color: black;
  text-decoration :none;
}

.map-list a img{
    width: 2.2rem;
}
.map-list a span{
    width: 100%;
    float: left;
}

</style>
  


// WEBPACK FOOTER //
// src/components/zwfwmap-phone/drawer_icon_list/drawer_icon_list.vue